/* eslint-disable */
import wechat from './wechat';

export default {
    install(Vue) {
        Vue.prototype.$wechat = wechat;
        Vue.wechat = wechat;
    },
};




// WEBPACK FOOTER //
// ./src/plugins/wechat/index.js